__turbopack_context__.v({
  "card-link__action": "card-link-module-scss-module__uW0GEW__card-link__action",
  "card-link__content": "card-link-module-scss-module__uW0GEW__card-link__content",
  "card-link__image": "card-link-module-scss-module__uW0GEW__card-link__image",
});
